import { AVEN_ADVISOR_UTM_SOURCE } from 'aven_types'

export const buildTaggedAutoApplicationUrl = (autoApplicationUrl: string, avenAdvisorLeadId: number | null): string => {
    const tags: { utm_source: string; utm_content: string; source_id?: number } = { utm_source: AVEN_ADVISOR_UTM_SOURCE, utm_content: 'today_tab' }
    if (avenAdvisorLeadId) {
        tags.source_id = avenAdvisorLeadId
    }
    return buildTaggedApplicationUrl(autoApplicationUrl, tags)
}

export const buildTaggedApplicationUrl = (url: string, tags: object): string => {
    const queryParams = Object.entries(tags)
        .map(([key, value]) => `${key}=${value}`)
        .join('&')
    return `${url}${url.includes('?') ? '&' : '?'}${queryParams}`
}

/**
 * Normalizes a URL by removing protocol (http/https) and www prefix for comparison purposes
 * @param url - The URL to normalize
 * @returns The normalized URL (e.g., "https://www.aven.com" -> "aven.com")
 */
export const normalizeUrlForComparison = (url: string): string => {
    if (!url) return ''

    return url
        .toLowerCase() // Normalize case
        .replace(/^https?:\/\//, '') // Remove protocol
        .replace(/^www\./, '') // Remove www prefix
        .split('/')[0] // Remove path and any following parts
}

/**
 * Checks if a URL matches any of the allowed origins using normalized comparison
 * @param targetUrl - The URL to check
 * @param allowedOrigins - Array of allowed origin URLs
 * @returns true if the URL matches any allowed origin, false otherwise
 */
export const isUrlInAllowedOrigins = (targetUrl: string, allowedOrigins: string[]): boolean => {
    if (!targetUrl || !allowedOrigins.length) return false

    const normalizedTarget = normalizeUrlForComparison(targetUrl)

    return allowedOrigins.some((origin) => {
        if (!origin) return false
        const normalizedOrigin = normalizeUrlForComparison(origin)
        return normalizedTarget === normalizedOrigin
    })
}
